export default __webpack_public_path__ + "static/media/game-score-win-2.0b0fa669.mp3";